import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import VTooltip from 'v-tooltip'
import VueSweetalert2 from 'vue-sweetalert2';
import VueBreadcrumbs from 'vue-2-breadcrumbs';
import Vue2TouchEvents from 'vue2-touch-events'

import 'sweetalert2/dist/sweetalert2.min.css';
import moment from "moment";

Vue.config.productionTip = false
Vue.prototype.$http = Axios;


const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
Axios.defaults.baseURL = 'https://api.svitpro.com.ua';
Axios.defaults.withCredentials = true
Vue.use(VueAxios, Axios)
Vue.use(VTooltip)
Vue.use(VueSweetalert2)
Vue.use(VueBreadcrumbs);
Vue.use(Vue2TouchEvents)
Axios.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      config.withCredentials = true;
      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    }
);

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
    subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
    subscribers.push(callback)
}

Axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    const { config, response } = error
    const originalRequest = config

    if ( response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true

            // instead of this store call you would put your code to get new token
            store.dispatch('refresh').then((access_token) => {
                isAlreadyFetchingAccessToken = false
                onAccessTokenFetched(access_token.data.jwtToken)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
            addSubscriber(access_token => {
                originalRequest.headers.Authorization = 'Bearer ' + access_token
                resolve(Axios(originalRequest))
            })
        })
        return retryOriginalRequest
    }
    return Promise.reject(error)
})

Vue.filter('formatDate', function (value) {
    if (value) {
        moment.locale('uk')
        return moment(String(value)).format('DD.MM.YYYY HH:mm:ss')
    }
})
Vue.filter('formatOnlyDate', function (value) {
    if (value) {
        moment.locale('uk')
        return moment(String(value)).format('DD.MM.YYYY')
    }
})
Vue.filter('formatDateMob', function (value) {
    if (value) {
        moment.locale('uk')
        return moment(String(value)).format('HH:mm:ss')
    }
})
Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('uK', {
        // style: 'currency',
        // currency: 'UAH',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
